import { Platform } from 'react-native';
import type { DatadogConfigInit } from '@sg/expo-datadog-client';
import { datadog } from '@sg/expo-datadog-client';

import { getEnvVars } from '@order/utils';

const environment = getEnvVars();

// ────────────────────────────────────────────────────────────────────────────────

const CONFIG: DatadogConfigInit = {
  applicationId: environment.DD_RUM_APPLICATION_ID,
  clientToken: environment.DD_RUM_CLIENT_TOKEN,
  env: environment.DD_RUM_ENVIRONMENT,
  version: environment.APP_VERSION,

  // RN alias of `service`
  serviceName: `order-app-${Platform.OS}`,
  // The domain + tld will match with subdomains as well
  // Ex: 'example.com' will match 'example.com' and 'api.example.com'.
  // @TODO: review this + consider old regex /https:\/\/.*\.sweetgreen\.com/,
  firstPartyHosts: [
    'sweetgreen.com',
    'https://order.sweetgreen.com',
    'https://order-development.sweetgreen.com',
    'https://order-staging.sweetgreen.com',
    'https://replatforming.sweetgreen.com',
    'https://replatforming-development.sweetgreen.com',
    'https://replatforming-staging.sweetgreen.com',
    'https://gateway.sweetgreen.com',
    'https://gateway-development.sweetgreen.com',
    'https://gateway-staging.sweetgreen.com',
    environment.GRAPHQL_ENDPOINT,
  ],
};

// ────────────────────────────────────────────────────────────────────────────────

export const initDatadog = async () => {
  await datadog.init(CONFIG);
};
